
import React from 'react';

export default function TransparencySection() {
  const metrics = [
    {
      title: 'Families Supported',
      current: '0',
      target: '2,000',
      icon: 'ri-home-heart-line'
    },
    {
      title: 'PHCs Enabled',
      current: '0',
      target: '100',
      icon: 'ri-hospital-line'
    },
    {
      title: 'Kits Distributed',
      current: '0',
      target: '2,500',
      icon: 'ri-medicine-bottle-line'
    },
    {
      title: 'App Users Screened',
      current: '0',
      target: '6,000',
      icon: 'ri-smartphone-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-8">
            Transparency & Accountability
          </h2>
          <p className="text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-12">
            "Every rupee will be tracked, every donation will be accounted for."
          </p>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Impact will be measured by:
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {metrics.map((metric, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-3xl flex items-center justify-center mx-auto mb-4">
                <i className={`${metric.icon} text-2xl text-[#12B6B6]`}></i>
              </div>
              <h3 className="text-lg font-semibold text-black mb-2">{metric.title}</h3>
              <div className="text-3xl font-bold text-[#12B6B6] mb-1">{metric.current}</div>
              <div className="text-sm text-gray-600">of {metric.target} target</div>
            </div>
          ))}
        </div>

        {/* Dashboard Preview */}
        <div className="bg-[#FAFAFA] rounded-3xl p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-black mb-4">Real-Time Impact Dashboard</h3>
            <p className="text-gray-600">Live tracking of every donation and its impact (launching soon)</p>
          </div>

          {/* Mock Dashboard */}
          <div className="bg-white rounded-2xl p-6 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Fund Utilization */}
              <div className="text-center">
                <div className="text-2xl font-bold text-[#12B6B6] mb-1">85%</div>
                <div className="text-sm text-gray-600">Direct Program Impact (Target)</div>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                  <div className="bg-gray-300 h-2 rounded-full" style={{ width: '100%' }}></div>
                </div>
              </div>

              {/* Monthly Growth */}
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-400 mb-1">--</div>
                <div className="text-sm text-gray-600">Monthly Growth Rate</div>
                <div className="flex items-center justify-center mt-2">
                  <i className="ri-time-line text-gray-400 mr-1"></i>
                  <span className="text-xs text-gray-400">Coming soon</span>
                </div>
              </div>

              {/* Satisfaction Score */}
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-400 mb-1">--</div>
                <div className="text-sm text-gray-600">Beneficiary Rating</div>
                <div className="flex justify-center mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-line text-gray-300"></i>
                  ))}
                </div>
              </div>
            </div>

            {/* Live Updates */}
            <div className="mt-6 pt-6 border-t border-gray-100">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                  <span className="text-gray-600">Dashboard will go live once program launches</span>
                </div>
                <div className="flex items-center space-x-4 text-gray-400">
                  <span>₹0 deployed</span>
                  <span>•</span>
                  <span>0 beneficiaries</span>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 mt-8">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-[#12B6B6]"></i>
              <span className="text-sm text-gray-600">80G Tax Exempt</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-file-shield-line text-[#12B6B6]"></i>
              <span className="text-sm text-gray-600">Quarterly Audits Planned</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-eye-line text-[#12B6B6]"></i>
              <span className="text-sm text-gray-600">Complete Transparency</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-[#12B6B6]"></i>
              <span className="text-sm text-gray-600">Real-time Tracking (Soon)</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
